import { Routes, RouterModule } from '@angular/router';
import { AuthGuard, SaveGuard } from '../services/';
import { MainComponent } from './main/main.component';
import { PerfilComponent } from './main/perfil/perfil.component';
import { HojaDeConsultaComponent } from './hojadeconsulta/hojadeconsulta.component';
import { ConsultaComponent } from './consulta/consulta.component';
import { LoginComponent } from './login/login.component';
import { ResumenpacienteComponent } from './consulta/resumenpaciente/resumenpaciente.component';
import { AlergiasComponent } from './consulta/alergias/alergias.component';
import { AlergiasDetalleComponent } from './consulta/alergias/alergiasdetalle/alergiasdetalle.component';
import { FarmacosComponent } from './consulta/farmacos/farmacos.component';
import { VacunasComponent } from './consulta/vacunas/vacunas.component';
import { HabitosComponent } from './consulta/habitos/habitos.component';
import { DocumentosComponent } from './consulta/documentos/documentos.component';
import { DocumentosDetalleComponent } from './consulta/documentos/detalledocumentos/detalledocumentos.component';
import { ConstantesComponent } from './consulta/constantes/constantes.component';
import { AltaConstanteComponent } from './consulta/constantes/altaconstante/altaconstante.component';
import { HojaDeSeguimientoComponent } from './consulta/hojadeseguimiento/hojadeseguimiento.component';
import { MotivosConsultaComponent } from './consulta/hojadeseguimiento/motivosconsulta/motivosconsulta.component';
import { MotivosDetalleComponent } from
'./consulta/hojadeseguimiento/motivosconsulta/motivosconsultadetalle/motivosdetalle.component';
import { AnamnesisComponent } from './consulta/hojadeseguimiento/anamnesis/anamnesis.component';
import { ExploracionComponent } from './consulta/hojadeseguimiento/exploracion/exploracion.component';
import { JuicioDiagnosticoComponent } from './consulta/hojadeseguimiento/juiciodiagnostico/juiciodiagnostico.component';
import { JuicioDiagnosticoDetalleComponent } from
'./consulta/hojadeseguimiento/juiciodiagnostico/juiciodiagnosticodetalle/juiciodiagnosticodetalle.component';
import { PlanActuacionComponent } from './consulta/hojadeseguimiento/planactuacion/planactuacion.component';
import { PlanActuacionDetalleComponent } from './consulta/hojadeseguimiento/planactuacion/planactuaciondetalle/planactuaciondetalle.component';
import { CitasComponent } from './consulta/citas/citas.component';
import { CitasAltaComponent } from './consulta/citas/citasalta/citasalta.component';
import { CitasDetalleComponent } from './consulta/citas/citasdetalle/citasdetalle.component';
import { NotasComponent } from './consulta/notas/notas.component';
import { NotasDetalleComponent } from './consulta/notas/notasdetalle/notasdetalle.component';
import { DiagnosticosComponent } from './consulta/diagnosticos/diagnosticos.component';
import { DiagnosticosDetalleComponent } from './consulta/diagnosticos/diagnosticosdetalle/diagnosticosdetalle.component';
import { AnamnesisDetalleComponent } from './consulta/hojadeseguimiento/anamnesis/anamnesisdetalle/anamnesisdetalle.component';
import { ExploracionDetalleComponent } from './consulta/hojadeseguimiento/exploracion/exploraciondetalle/exploraciondetalle.component';
import { TecnicasTerapeuticasComponent } from './consulta/tecnicasterapeuticas/tecnicasterapeuticas.component';
import { TecnicasTerapeuticasDetalleComponent } from
'./consulta/tecnicasterapeuticas/tecnicasterapeuticasdetalle/tecnicasterapeuticasdetalle.component';
import { TecnicasDiagnosticasComponent } from './consulta/tecnicasdiagnosticas/tecnicasdiagnosticas.component';
import { TecnicasDiagnosticasDetalleComponent } from './consulta/tecnicasdiagnosticas/tecnicasdiagnosticasdetalle/tecnicasdiagnosticasdetalle.component';
import { ModAnamnesisComponent } from './consulta/modanamnesis/modanamnesis.component';

import { CerradosComponent } from './consulta/modanamnesis/cerrados/cerrados.component';
import { CerradosDetalleComponent } from './consulta/modanamnesis/cerrados/cerradosdetalle/cerradosdetalle.component';
import { AltaCerradosComponent } from './consulta/modanamnesis/cerrados/altacerrados/altacerrados.component';

import { PatronesFuncionalesComponent } from './consulta/modanamnesis/patronesfuncionales/patronesfuncionales.component';
import { PatronesDisponiblesComponent } from './consulta/modanamnesis/patronesfuncionales/patronesdisponibles/patronesdisponibles.component';
import { PatronesDetalleComponent } from './consulta/modanamnesis/patronesfuncionales/patronesdetalle/patronesdetalle.component';

import { ProgramasFuncionalesComponent } from './consulta/modanamnesis/programasfuncionales/programasfuncionales.component';
import { ProgramasDisponiblesComponent } from './consulta/modanamnesis/programasfuncionales/programasdisponibles/programasdisponibles.component';
import { ProgramasDetalleComponent } from './consulta/modanamnesis/programasfuncionales/programasdetalle/programasdetalle.component';

import { TestComponent } from './consulta/modanamnesis/test/test.component';
import { TestDisponiblesComponent } from './consulta/modanamnesis/test/testdisponibles/testdisponibles.component';
import { TestDetalleComponent } from './consulta/modanamnesis/test/testdetalle/testdetalle.component';

import { PreguntasObligatoriasComponent } from './consulta/modanamnesis/preguntasobligatorias/preguntasobligatorias.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  {
    path: 'main', component: MainComponent, canActivate: [AuthGuard], children: [
      {
        path: '',
        component: HojaDeConsultaComponent,
      },
      {
        path: 'perfil',
        component: PerfilComponent,
      },
      {
        path: 'consulta/:id', component: ConsultaComponent, children: [
          { path: '', component: ResumenpacienteComponent },
          {
            path: 'alergias', children: [
              { path: '', component: AlergiasComponent },
              { path: 'alta', component: AlergiasDetalleComponent, canDeactivate: [SaveGuard] },
              { path: 'editar/:id', component: AlergiasDetalleComponent, canDeactivate: [SaveGuard] },
            ],
          },
          {
            path: 'hojadeseguimiento', component: HojaDeSeguimientoComponent, children: [
              { path: 'motivos', component: MotivosConsultaComponent, outlet: 'hojadeseguimiento' },
              { path: 'motivosdetalle', component: MotivosDetalleComponent, outlet: 'hojadeseguimiento', canDeactivate: [SaveGuard] },
              { path: 'anamnesis', component: AnamnesisComponent, outlet: 'hojadeseguimiento' },
              { path: 'anamnesisdetalle', component: AnamnesisDetalleComponent, outlet: 'hojadeseguimiento', canDeactivate: [SaveGuard] },
              { path: 'exploracion', component: ExploracionComponent, outlet: 'hojadeseguimiento' },
              { path: 'exploraciondetalle', component: ExploracionDetalleComponent, outlet: 'hojadeseguimiento', canDeactivate: [SaveGuard] },
              { path: 'juicio', component: JuicioDiagnosticoComponent, outlet: 'hojadeseguimiento' },
              { path: 'juiciodetalle', component: JuicioDiagnosticoDetalleComponent, outlet: 'hojadeseguimiento' },
              { path: 'plan', component: PlanActuacionComponent, outlet: 'hojadeseguimiento' },
              { path: 'plandetalle', component: PlanActuacionDetalleComponent, outlet: 'hojadeseguimiento', canDeactivate: [SaveGuard] },
            ],
          },
          { path: 'farmacos', component: FarmacosComponent },
          { path: 'vacunas', component: VacunasComponent },
          { path: 'habitos', component: HabitosComponent },
          { path: 'constantes', component: ConstantesComponent },
          {
            path: 'constantes', children: [
              { path: '', component: ConstantesComponent },
              { path: 'alta', component: AltaConstanteComponent, canDeactivate: [SaveGuard] },
            ],
          },
          {
            path: 'tecnicasterapeuticas', children: [
              { path: '', component: TecnicasTerapeuticasComponent },
              { path: 'alta', component: TecnicasTerapeuticasDetalleComponent, canDeactivate: [SaveGuard] },
            ],
          },
          {
            path: 'tecnicasdiagnosticas', children: [
              { path: '', component: TecnicasDiagnosticasComponent },
              { path: 'alta', component: TecnicasDiagnosticasDetalleComponent, canDeactivate: [SaveGuard] },
            ],
          },
          {
            path: 'citas', children: [
              { path: '', component: CitasComponent },
              { path: 'alta', component: CitasAltaComponent, canDeactivate: [SaveGuard] },
            ],
          },
          {
            path: 'notas', children: [
              { path: '', component: NotasComponent },
              { path: 'alta', component: NotasDetalleComponent, canDeactivate: [SaveGuard] },
              { path: 'editar/:id', component: NotasDetalleComponent, canDeactivate: [SaveGuard] },
            ],
          },
          {
            path: 'diagnosticos', children: [
              { path: '', component: DiagnosticosComponent },
              /* { path: 'alta', component: DiagnosticosDetalleComponent, canDeactivate: [SaveGuard] }*/
            ],
          },
          {
            path: 'documentos', children: [
              { path: '', component: DocumentosComponent },
              { path: 'documentosdetalle', component: DocumentosDetalleComponent },
              /* { path: 'alta', component: DiagnosticosDetalleComponent, canDeactivate: [SaveGuard] }*/
            ],
          },
          {
            path: 'modanamnesis', component: ModAnamnesisComponent, children: [
              { path: 'patronesfuncionales', component: PatronesFuncionalesComponent, outlet: 'modanamnesis'},
              { path: 'patronesdetalle', component: PatronesDetalleComponent, outlet: 'modanamnesis', canDeactivate: [SaveGuard] },
              { path: 'patronesdisponibles', component: PatronesDisponiblesComponent, outlet: 'modanamnesis' },
              { path: 'programasfuncionales', component: ProgramasFuncionalesComponent, outlet: 'modanamnesis' },
              { path: 'programasdetalle', component: ProgramasDetalleComponent, outlet: 'modanamnesis', canDeactivate: [SaveGuard] },
              { path: 'programasdisponibles', component: ProgramasDisponiblesComponent, outlet: 'modanamnesis' },
              { path: 'test', component: TestComponent, outlet: 'modanamnesis' },
              { path: 'testdetalle', component: TestDetalleComponent, outlet: 'modanamnesis', canDeactivate: [SaveGuard] },
              { path: 'testdisponibles', component: TestDisponiblesComponent, outlet: 'modanamnesis' },
              { path: 'cerrados', component: CerradosComponent, outlet: 'modanamnesis'},
              { path: 'altacerrados', component: AltaCerradosComponent, outlet: 'modanamnesis'},
              { path: 'cerradosdetalle', component: CerradosDetalleComponent, outlet: 'modanamnesis'},
              { path: 'preguntasobligatorias', component: PreguntasObligatoriasComponent, outlet: 'modanamnesis'},
            ],
          },
        ],
      },
    ],
  },
  { path: '**', component: LoginComponent },
];

export const appRoutingProviders: any[] = [];

export const appRoutes: any = RouterModule.forRoot(routes, { useHash: true });



// WEBPACK FOOTER //
// ./src/app/app.routes.ts